import React from "react";
import { Button } from "../../components/Button";
import { X, Plus, ChevronRight } from "lucide-react";
import { IconSectionProps } from "./types";

export const IconSection: React.FC<IconSectionProps> = ({
  themeIcons,
  isExpanded,
  onToggle,
  isLoading,
  onDeleteIcon,
  onOpenIconPicker,
}) => {
  return (
    <div className="bc-theme-editor-section">
      <div className="bc-theme-editor-section-header" onClick={onToggle}>
        <h3 className="bc-theme-editor-section-title">
          Images and Icons
          <span className="bc-theme-editor-section-count">
            {Object.keys(themeIcons).length}
          </span>
        </h3>
        <ChevronRight
          size={16}
          className={`bc-theme-editor-section-chevron ${isExpanded ? "expanded" : ""}`}
        />
      </div>

      {isExpanded && (
        <div className="bc-theme-editor-section-content">
          <div className="bc-theme-editor-list">
            {Object.entries(themeIcons).map(([key, icon]) => (
              <div key={key} className="bc-theme-editor-row">
                <div className="bc-theme-editor-asset-preview">
                  <img src={icon.url} alt={icon.name} />
                </div>
                <input
                  type="text"
                  className="bc-theme-editor-input"
                  value={icon.name}
                  disabled
                />
                <button
                  className="bc-theme-editor-delete-btn"
                  onClick={() => onDeleteIcon(key)}
                  disabled={isLoading}
                  aria-label="Delete icon"
                >
                  <X size={16} />
                </button>
              </div>
            ))}

            <Button
              variant="ghost"
              size="sm"
              leftIcon={<Plus size={12} />}
              onClick={onOpenIconPicker}
              disabled={isLoading}
            >
              Add Image
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
